import { render, staticRenderFns } from "./revisionCommissionDialog.vue?vue&type=template&id=4806390f"
import script from "./revisionCommissionDialog.vue?vue&type=script&lang=js"
export * from "./revisionCommissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports